import useQuery from "@Hooks/useQuery";
import OTPComponent from "@Molecule/OTPInput";
import { sendOTP, verifyOTP } from "@Services/officer/recruitment";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Styles from "./style.module.scss";
import InputField from "@Molecule/InputField";
import Icon from "@Atom/Icon";

export default function OTPConfirmationModal({
  data,
  handleSubmit,
  errorApi = null,
  loading = false,
  hashID = "",
  isUpdate = false,
  valueUpdate,
  setValueUpdate = () => {},
  setHashQuery = () => {},
  setIsOtpModal = () => {},
}) {
  const [isSubmitting, setIsSubmiting] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const defaultStep = sessionStorage?.getItem("stepOTP") || 1;

  const [step, setStep] = useState(+defaultStep || 1);

  useEffect(() => {
    if (isUpdate) {
      sessionStorage?.setItem("stepOTP", step || 1);
    }
  }, [isUpdate, step]);

  const query = useQuery();
  const hash = query.get("h") || hashID;

  const [OTP, setOTP] = useState(null);
  const [errorOTP, setErrorOTP] = useState(null);
  const [error, setError] = useState(null);
  const [onVerify, setOnVerify] = useState(false);

  const [ableResend, setAbleResend] = useState(false);

  useEffect(() => {
    setOTP(null);
    setErrorOTP(null);
    setError(null);
  }, [hash]);

  useEffect(() => {
    setError(errorApi);
  }, [errorApi]);

  const COLOR_CODES = {
    info: {
      color: "green",
    },
  };

  let remainingPathColor = COLOR_CODES.info.color;

  const handleResend = async () => {
    try {
      setIsSubmiting(true);

      const { response } = await sendOTP(
        step === 3 && valueUpdate?.newPhoneNumber
          ? valueUpdate?.newPhoneNumber?.startsWith("62")
            ? valueUpdate?.newPhoneNumber
            : "62" + valueUpdate?.newPhoneNumber
          : data?.phoneNumber?.startsWith("62")
          ? data?.phoneNumber
          : "62" + data?.phoneNumber
      );

      navigate(`${pathname}?h=${response?.hash}&v=true`, { replace: true });
      setOtpTimer(60);
      setIsSubmiting(false);
    } catch (err) {
      const errorMessage = err?.response?.data?.error || "something went wrong";
      setIsSubmiting(false);
      if (errorMessage?.toLowerCase()?.includes("fill all field")) {
        setError("Cek kembali form dan pastikan semua data telah terisi");
      } else {
        setError(errorMessage);
      }
    }
  };

  // function DataURIToBlob(dataURI) {
  //   const splitDataURI = dataURI.split(',')
  //   const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  //   const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  //   const ia = new Uint8Array(byteString.length)
  //   for (let i = 0; i < byteString.length; i++)
  //     ia[i] = byteString.charCodeAt(i)

  //   return new Blob([ia], { type: mimeString })
  // }

  const handleConfirm = async (e) => {
    e.preventDefault();
    try {
      setOnVerify(true);
      await verifyOTP(hash, OTP);

      handleSubmit();
      sessionStorage?.removeItem("stepOTP");
      // setIsDone(true);
    } catch (err) {
      if (err?.response?.data?.error?.toLowerCase()?.includes("wrong code")) {
        setError("Wrong OTP input");
      } else {
        setError(err?.response?.data?.error);
      }
    }
    setOnVerify(false);
  };

  const [isVerifying, setIsVerifying] = useState(false);

  const [otpTimer, setOtpTimer] = useState(0);
  const [circularValue, setCircularValue] = useState(100);

  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const [strokeDasharray, setStrokeDasharray] = useState(
    `${circumference} ${circumference}`
  );

  useEffect(() => {
    setOtpTimer(60);
  }, [OTP]);

  const secondsToTime = (secs) => {
    // var hours = Math.floor(secs / (60 * 60));
    var divisor_for_minutes = secs % (60 * 60);
    var minutes = Math.floor(divisor_for_minutes / 60);
    var divisor_for_seconds = divisor_for_minutes % 60;
    var seconds = Math.ceil(divisor_for_seconds);
    if (minutes < 10) {
      minutes = `0${minutes}`;
    }
    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return minutes + ":" + seconds;
  };
  useEffect(() => {
    let otpInterval = setInterval(() => {
      setOtpTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(otpInterval);
  }, []);

  useEffect(() => {
    setCircularValue((otpTimer / 60) * 100);

    // Update strokeDasharray untuk animasi progres lingkaran
    const progress = (otpTimer / 60) * circumference;
    setStrokeDasharray(`${progress} ${circumference}`);
  }, [otpTimer]);

  const onClickPhoneVerification = async (e, type) => {
    e.preventDefault();
    try {
      setIsVerifying(true);
      if (type === "back") {
        const { response } = await sendOTP(
          data?.phoneNumber?.startsWith("62")
            ? data?.phoneNumber
            : "62" + data?.phoneNumber
        );
        setIsVerifying(false);
        setHashQuery(response?.hash);
        setIsOtpModal("true");
        setStep(1);
        setError("");
        setOtpTimer(60);
      } else {
        if (
          (data?.phoneNumber?.startsWith("62") &&
            data?.phoneNumber !== "62" + valueUpdate?.oldPhoneNumber) ||
          (!data?.phoneNumber?.startsWith("62") &&
            data?.phoneNumber !== valueUpdate?.oldPhoneNumber)
        ) {
          setError("Nomor whatsApp lama tidak sesuai");
          setIsVerifying(false);
        } else {
          const { response } = await sendOTP(
            "62" + valueUpdate?.newPhoneNumber
          );
          setIsVerifying(false);
          setHashQuery(response?.hash);
          setIsOtpModal("true");
          setStep(3);
          setOtpTimer(60);
          setError("");
        }
      }
    } catch (error) {
      setError(error?.response?.data?.error);
      setIsVerifying(false);
      console.log(error);
    }
  };

  useEffect(() => {
    if (step === 1) {
      setValueUpdate({
        oldPhoneNumber: "",
        newPhoneNumber: "",
      });
    }
  }, [step, setValueUpdate]);

  const contentUpdate = useMemo(() => {
    switch (+step) {
      case 1:
        return (
          <div className={Styles.container}>
            <div className={Styles.header}>
              <h3>Konfirmasi OTP</h3>
              <p>
                {`Silahkan masukan kode OTP yang telah kami kirim ke nomor +62 8`}
                {data?.phoneNumber?.length &&
                  [
                    ...Array(
                      (data?.phoneNumber?.length > 3
                        ? data?.phoneNumber?.length
                        : 3) - 3
                    ),
                  ]?.map((e, i) => {
                    return (
                      <span className="busterCards" key={i}>
                        *
                      </span>
                    );
                  })}
                {data?.phoneNumber?.slice(
                  data?.phoneNumber?.length - 2,
                  data?.phoneNumber?.length
                )}{" "}
                {"untuk konformasi data kamu"}
              </p>

              <div className={Styles.updatePhoneNumberBox}>
                <span>
                  Ingin mengubah nomor Whatsapp?{" "}
                  <span
                    onClick={() => {
                      setStep(2);
                    }}
                  >
                    Ubah Sekarang
                  </span>
                </span>
              </div>
            </div>
            <div className={Styles.content}>
              <form onSubmit={handleConfirm}>
                <OTPComponent
                  onChange={(value) => {
                    setOTP(value || "");
                    setErrorOTP(null);
                    setError(null);
                  }}
                  alert={errorOTP}
                />
                <span
                  className={
                    errorOTP || error ? Styles.alertText : Styles.noAlert
                  }
                >
                  {errorOTP || error || "no alert"}
                </span>

                <div className={Styles.resendWrapper}>
                  <div className={Styles.resendController}>
                    <button
                      type="button"
                      disabled={otpTimer !== 0}
                      onClick={handleResend}
                      className={
                        otpTimer === 0
                          ? Styles.ableResend
                          : Styles.disableResend
                      }
                    >
                      {onVerify ? "Requesting OTP" : "Request again?"}
                    </button>
                  </div>
                  <div className={Styles.timerWrapper}>
                    <div className={Styles.baseTimer}>
                      <svg
                        className={Styles.SVG}
                        viewBox="0 0 100 100"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g className={Styles.circle}>
                          <circle
                            className={Styles.pathElapsed}
                            cx="50"
                            cy="50"
                            r="45"
                          />
                          <path
                            id="base-timer-path-remaining"
                            strokeDasharray={strokeDasharray}
                            className={`${Styles.pathRemaining} ${remainingPathColor}`}
                            d="
                M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0
              "
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <span>{secondsToTime(otpTimer)}</span>
                  </div>
                </div>
                <div className={Styles.buttonWrapper}>
                  <button
                    type="submit"
                    disabled={
                      !OTP ||
                      OTP?.length < 4 ||
                      onVerify ||
                      isSubmitting ||
                      loading
                    }
                  >
                    {onVerify && loading
                      ? "Mengonfirmasi..."
                      : "Konfirmasi dan Kirim"}
                  </button>
                </div>
                {/* <DownloadOption /> */}
              </form>
            </div>
          </div>
        );

      case 2:
        return (
          <div className={Styles.container}>
            <div className={Styles.header}>
              <div
                className={`${Styles.backBox} ${
                  isVerifying && Styles.disabled
                }`}
                onClick={(e) => {
                  if (!isVerifying) {
                    onClickPhoneVerification(e, "back");
                  }
                }}
              >
                <div>
                  <Icon
                    icon={"arrow-left-back"}
                    size={16}
                    color={isVerifying ? "#9E9E9E" : "#1571DE"}
                  />
                </div>
                <span>Kembali</span>
              </div>
              <h3>Ubah nomor Whatsapp</h3>
              <p>
                Masukkan nomor WhatsApp lama Anda, dan masukkan nomor WhatsApp
                yang baru.
              </p>
            </div>
            <div className={`${Styles.content} ${Styles.contentStepTwo}`}>
              <InputField
                type="phoneVerification"
                value={valueUpdate?.oldPhoneNumber}
                title="Nomor Whatsapp Lama"
                placeholder="Nomor Whatsapp Lama"
                onChange={(e) =>
                  setValueUpdate((prev) => ({
                    ...prev,
                    oldPhoneNumber: e.target.value,
                  }))
                }
                required
                requiredLabel="Wajib diisi"
                isError={error === "Nomor whatsApp lama tidak sesuai"}
                errorText={error}
                isButton
              />

              <InputField
                type="phoneVerification"
                value={valueUpdate?.newPhoneNumber}
                title="Nomor Whatsapp Baru"
                placeholder="Nomor Whatsapp Baru"
                onChange={(e) =>
                  setValueUpdate((prev) => ({
                    ...prev,
                    newPhoneNumber: e.target.value,
                  }))
                }
                required
                requiredLabel="Wajib diisi"
                isButton
              />

              <div className={Styles.buttonBox}>
                {error && <span>*{error}</span>}
                <div className={Styles.buttonWrapper}>
                  <button
                    disabled={
                      isVerifying ||
                      !valueUpdate?.oldPhoneNumber ||
                      !valueUpdate?.newPhoneNumber
                    }
                    onClick={(e) => {
                      onClickPhoneVerification(e, "next");
                    }}
                  >
                    {isVerifying ? "Loading..." : "Simpan"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div className={Styles.container}>
            <div className={Styles.header}>
              <h3>Konfirmasi OTP</h3>
              <p>
                {`Silahkan masukan kode OTP yang telah kami kirim ke nomor +62 8`}
                {valueUpdate?.newPhoneNumber?.length &&
                  [
                    ...Array(
                      (valueUpdate?.newPhoneNumber?.length > 3
                        ? valueUpdate?.newPhoneNumber?.length
                        : 3) - 3
                    ),
                  ]?.map((e, i) => {
                    return (
                      <span className="busterCards" key={i}>
                        *
                      </span>
                    );
                  })}
                {valueUpdate?.newPhoneNumber?.slice(
                  valueUpdate?.newPhoneNumber?.length - 2,
                  valueUpdate?.newPhoneNumber?.length
                )}{" "}
                {"untuk konformasi data kamu"}
              </p>

              <div className={Styles.updatePhoneNumberBox}>
                <span>
                  Ingin mengubah nomor Whatsapp?{" "}
                  <span
                    onClick={() => {
                      setStep(2);
                    }}
                  >
                    Ubah Sekarang
                  </span>
                </span>
              </div>
            </div>
            <div className={Styles.content}>
              <form onSubmit={handleConfirm}>
                <OTPComponent
                  onChange={(value) => {
                    setOTP(value || "");
                    setErrorOTP(null);
                    setError(null);
                  }}
                  alert={errorOTP}
                />
                <span
                  className={
                    errorOTP || error ? Styles.alertText : Styles.noAlert
                  }
                >
                  {errorOTP || error || "no alert"}
                </span>

                <div className={Styles.resendWrapper}>
                  <div className={Styles.resendController}>
                    <button
                      type="button"
                      disabled={otpTimer !== 0}
                      onClick={handleResend}
                      className={
                        otpTimer === 0
                          ? Styles.ableResend
                          : Styles.disableResend
                      }
                    >
                      {onVerify ? "Requesting OTP" : "Request again?"}
                    </button>
                  </div>
                  <div className={Styles.timerWrapper}>
                    <div className={Styles.baseTimer}>
                      <svg
                        className={Styles.SVG}
                        viewBox="0 0 100 100"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g className={Styles.circle}>
                          <circle
                            className={Styles.pathElapsed}
                            cx="50"
                            cy="50"
                            r="45"
                          />
                          <path
                            id="base-timer-path-remaining"
                            strokeDasharray={strokeDasharray}
                            className={`${Styles.pathRemaining} ${remainingPathColor}`}
                            d="
                M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0
              "
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <span>{secondsToTime(otpTimer)}</span>
                  </div>
                </div>
                <div className={Styles.buttonWrapper}>
                  <button
                    type="submit"
                    disabled={
                      !OTP ||
                      OTP?.length < 4 ||
                      onVerify ||
                      isSubmitting ||
                      loading
                    }
                  >
                    {onVerify && loading
                      ? "Mengonfirmasi..."
                      : "Konfirmasi dan Kirim"}
                  </button>
                </div>
                {/* <DownloadOption /> */}
              </form>
            </div>
          </div>
        );

      default:
        return (
          <div className={Styles.container}>
            <div className={Styles.header}>
              <h3>Konfirmasi OTP</h3>
              <p>
                {`Silahkan masukan kode OTP yang telah kami kirim ke nomor +62 8`}
                {data?.phoneNumber?.length &&
                  [
                    ...Array(
                      (data?.phoneNumber?.length > 3
                        ? data?.phoneNumber?.length
                        : 3) - 3
                    ),
                  ]?.map((e, i) => {
                    return (
                      <span className="busterCards" key={i}>
                        *
                      </span>
                    );
                  })}
                {data?.phoneNumber?.slice(
                  data?.phoneNumber?.length - 2,
                  data?.phoneNumber?.length
                )}{" "}
                {"untuk konformasi data kamu"}
              </p>

              <div className={Styles.updatePhoneNumberBox}>
                <span>
                  Ingin mengubah nomor Whatsapp?{" "}
                  <span
                    onClick={() => {
                      setStep(2);
                    }}
                  >
                    Ubah Sekarang
                  </span>
                </span>
              </div>
            </div>
            <div className={Styles.content}>
              <form onSubmit={handleConfirm}>
                <OTPComponent
                  onChange={(value) => {
                    setOTP(value || "");
                    setErrorOTP(null);
                    setError(null);
                  }}
                  alert={errorOTP}
                />
                <span
                  className={
                    errorOTP || error ? Styles.alertText : Styles.noAlert
                  }
                >
                  {errorOTP || error || "no alert"}
                </span>

                <div className={Styles.resendWrapper}>
                  <div className={Styles.resendController}>
                    <button
                      type="button"
                      disabled={otpTimer !== 0}
                      onClick={handleResend}
                      className={
                        otpTimer === 0
                          ? Styles.ableResend
                          : Styles.disableResend
                      }
                    >
                      {onVerify ? "Requesting OTP" : "Request again?"}
                    </button>
                  </div>
                  <div className={Styles.timerWrapper}>
                    <div className={Styles.baseTimer}>
                      <svg
                        className={Styles.SVG}
                        viewBox="0 0 100 100"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g className={Styles.circle}>
                          <circle
                            className={Styles.pathElapsed}
                            cx="50"
                            cy="50"
                            r="45"
                          />
                          <path
                            id="base-timer-path-remaining"
                            strokeDasharray={strokeDasharray}
                            className={`${Styles.pathRemaining} ${remainingPathColor}`}
                            d="
                M 50, 50
                m -45, 0
                a 45,45 0 1,0 90,0
                a 45,45 0 1,0 -90,0
              "
                          ></path>
                        </g>
                      </svg>
                    </div>
                    <span>{secondsToTime(otpTimer)}</span>
                  </div>
                </div>
                <div className={Styles.buttonWrapper}>
                  <button
                    type="submit"
                    disabled={
                      !OTP ||
                      OTP?.length < 4 ||
                      onVerify ||
                      isSubmitting ||
                      loading
                    }
                  >
                    {onVerify && loading
                      ? "Mengonfirmasi..."
                      : "Konfirmasi dan Kirim"}
                  </button>
                </div>
                {/* <DownloadOption /> */}
              </form>
            </div>
          </div>
        );
    }
  }, [
    step,
    data,
    handleConfirm,
    errorOTP,
    error,
    ableResend,
    handleResend,
    onVerify,
    strokeDasharray,
    OTP,
    isSubmitting,
    loading,
    // time,
    valueUpdate,
    setValueUpdate,
    isVerifying,
    onClickPhoneVerification,
    secondsToTime,
    otpTimer,
  ]);

  if (isUpdate) {
    return <>{contentUpdate}</>;
  }

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <h3>Konfirmasi OTP</h3>
        <p>
          {`Masukan kode OTP yang kami kirim ke nomor Whatsapp +62 8`}
          {data?.phoneNumber?.length &&
            [
              ...Array(
                (data?.phoneNumber?.length > 3
                  ? data?.phoneNumber?.length
                  : 3) - 3
              ),
            ]?.map((e, i) => {
              return (
                <span className="busterCards" key={i}>
                  *
                </span>
              );
            })}
          {data?.phoneNumber?.slice(
            data?.phoneNumber?.length - 2,
            data?.phoneNumber?.length
          )}
        </p>
      </div>
      <div className={Styles.content}>
        <form onSubmit={handleConfirm}>
          <OTPComponent
            onChange={(value) => {
              setOTP(value || "");
              setErrorOTP(null);
              setError(null);
            }}
            alert={errorOTP}
          />
          <span
            className={errorOTP || error ? Styles.alertText : Styles.noAlert}
          >
            {errorOTP || error || "no alert"}
          </span>

          <div className={Styles.resendWrapper}>
            <div className={Styles.resendController}>
              <button
                type="button"
                disabled={otpTimer !== 0}
                onClick={handleResend}
                className={
                  otpTimer === 0 ? Styles.ableResend : Styles.disableResend
                }
              >
                {onVerify ? "Requesting OTP" : "Request again?"}
              </button>
            </div>
            <div className={Styles.timerWrapper}>
              <div className={Styles.baseTimer}>
                <svg
                  className={Styles.SVG}
                  viewBox="0 0 100 100"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g className={Styles.circle}>
                    <circle
                      className={Styles.pathElapsed}
                      cx="50"
                      cy="50"
                      r="45"
                    />
                    <path
                      id="base-timer-path-remaining"
                      strokeDasharray={strokeDasharray}
                      className={`${Styles.pathRemaining} ${remainingPathColor}`}
                      d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
                    ></path>
                  </g>
                </svg>
              </div>
              <span>{secondsToTime(otpTimer)}</span>
            </div>
          </div>
          <div className={Styles.buttonWrapper}>
            <button
              type="submit"
              disabled={
                !OTP || OTP?.length < 4 || onVerify || isSubmitting || loading
              }
            >
              {onVerify && loading
                ? "Mengonfirmasi..."
                : "Konfirmasi dan Kirim"}
            </button>
          </div>
          {/* <DownloadOption /> */}
        </form>
      </div>
    </div>
  );
}
